import React, { FC, SVGProps } from 'react';

import { useWindowSize } from 'hooks/breakpoints';
import { ReactComponent as Logo } from './logo.svg';
import { useTranslation } from 'react-i18next';

export const MOBILE_SIZE = { width: 97, height: 23 };
export const TABLET_SIZE = { width: 120, height: 29 };

export const CloverLogo: FC<SVGProps<SVGSVGElement>> = props => {
  const { isDesktop } = useWindowSize();
  const { t } = useTranslation();

  const logoSize = isDesktop ? TABLET_SIZE : MOBILE_SIZE;

  return <Logo {...logoSize} {...props} title={t('alt.cloverLogo')} />;
};
